import React from 'react';

export default ({ children }) => <main id="main-content">{children}</main>;
